// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-button_close__K0Y8\\+ {
    border: 0.5px solid var(--primary-color);
    z-index: 4;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    max-width: 100%;
    max-height: 100%;
    background: #fff;
    transition: background 0.4s;
    cursor: pointer;
    border-radius: 50%;

    --icon-stroke: 0.5px;
    --icon-color-custom: var(--primary-color);
}

.close-button_close__K0Y8\\+:hover {
    --icon-color-custom: #fff;
    background: var(--primary-color);
}

.close-button_close__K0Y8\\+ span {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    max-height: 100%;
}
.close-button_close__K0Y8\\+ span svg {
    max-width: 90%;
    max-height: 90%;
}
`, "",{"version":3,"sources":["webpack://./src/components/CloseButtonRounded/close-button.module.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;;IAElB,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":[".close {\n    border: 0.5px solid var(--primary-color);\n    z-index: 4;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 30px;\n    width: 30px;\n    max-width: 100%;\n    max-height: 100%;\n    background: #fff;\n    transition: background 0.4s;\n    cursor: pointer;\n    border-radius: 50%;\n\n    --icon-stroke: 0.5px;\n    --icon-color-custom: var(--primary-color);\n}\n\n.close:hover {\n    --icon-color-custom: #fff;\n    background: var(--primary-color);\n}\n\n.close span {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    max-width: 100%;\n    max-height: 100%;\n}\n.close span svg {\n    max-width: 90%;\n    max-height: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"close": `close-button_close__K0Y8+`
};
export default ___CSS_LOADER_EXPORT___;
